import { tokens } from "@/locales/translations/tokens";
import { useTranslation } from "react-i18next";

interface TranslatedPaginationProps {
  pageCount: number;
  pageIndex: number;
}

export function useTranslatedPaginationMessage({
  pageCount,
  pageIndex
}: TranslatedPaginationProps) {
  const  { t } = useTranslation();
  return pageCount === 0 ? 
    t(tokens.ui.common.pagination.pageOf, {
      current: "0",
      total: "0"
    }) : 
    t(tokens.ui.common.pagination.pageOf, {
      current: pageIndex,
      total: pageCount,
    });
}